import React from "react";
import Layout from "../../components/Layout/Layout";
import Feedback from "../../components/general/Feedback/Feedback";
import Downloads from "../../components/pages/Schemas/Downloads/Downloads";

const SchemasPage: React.FC = () => {
  return (
    <Layout>
      <Downloads />
      <Feedback />
    </Layout>
  );
};

export default SchemasPage;
